import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    GetSumAreaCommission({commit},payload){
        return new Promise((resolve, reject) => {
            api.get('/MemberAgentCommission/GetSumAreaCommission',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetSumTeamCommission({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/MemberAgentCommission/GetSumTeamCommission',payload, res => {
                resolve(res)
            }, err => {
                reject(err)
            }) 
        });
    },
    GetBoleCommission({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/MemberAgentCommission/GetSumBoleCommission',payload, res => {
                resolve(res)
            }, err => {
                reject(err)
            }) 
        });
    },
    GetMemberAgentCommissionList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemberAgentCommission/List',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetMemberAgentCommissionTeamList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemberAgentCommission/TeamList',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    }

}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/memberAgentCommission.js